import React, { useCallback } from 'react';
import { MenuItem } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';
import { TicketStatus } from 'flow/types/Tickets';

import { STATUS_LABEL_KEYS } from './state-labels';

interface Props {
    statusKey: TicketStatus;
    onSelect: (key: TicketStatus) => void;
}

const StatePickerItem = ({ statusKey, onSelect }: Props) => {
    const { i18next } = useAppContext();

    const onClick = useCallback(() => {
        onSelect(statusKey);
    }, [onSelect, statusKey]);

    return (
        <MenuItem>
            {({ focus }) => (
                <button
                    type="button"
                    onClick={onClick}
                    className={twMerge(
                        'flex w-full items-center rounded-sm px-2 py-2 text-start text-sm',
                        focus ? 'bg-gray-200' : '',
                    )}
                >
                    {i18next.t(STATUS_LABEL_KEYS[statusKey])}
                </button>
            )}
        </MenuItem>
    );
};

export default React.memo(StatePickerItem);
